import { environment } from '@gaodun.com/gtools';
import sensors from 'sa-sdk-javascript';
const apiEnv = environment.getApiEnv();
export function sensorsInit() {
    sensors.init({
        server_url: 'https://gaodun.datasink.sensorsdata.cn/sa?project=default&token=b9ea8de774df405c',
        name: 'sa',
        show_log: true,
        debug_mode: false,
        debug_mode_upload: false,
        heatmap: {
            clickmap: 'default',
            scroll_notice_map: 'default',
        },
    });
    sensors.quick('autoTrack', {
        platform: 'space-pc',
    });
}

export function bindEvents(key: string, data: any) {
    setTimeout(() => {
        sensors.track(key, { ...data });
    }, 500);
}
